import { type Translate } from 'next-translate';
import React from 'react';
import { Container } from '@/components/elements/Container';
import { LinkWithQuery } from '@/components/elements/LinkWithQuery';
import { useIsMobile } from '@/hooks';
import ArrowIcon from '@/public/icons/arrow-thin.svg';
import { type FormatConverterConfig } from '../../../../types';
import styles from './Formats.module.scss';

interface Props {
	data: FormatConverterConfig;
	t: Translate;
}
export const Formats: React.FC<Props> = ({ data, t }) => {
	const isMobile = useIsMobile();
	const [activeTabId, setActiveTabId] = React.useState<string>(
		data.lists[0]?.id || '',
	);

	const activeList =
		data.lists.find(list => list.id === activeTabId) || data.lists[0];

	return (
		<section className={styles['format-converter']}>
			<Container className={styles['format-converter__container']}>
				<h2 className={styles['format-converter__title']}>{t(data.title)}</h2>

				{isMobile ? (
					<div className={styles['format-converter__mobile']}>
						<div className={styles['format-converter__tabs']}>
							{data.lists.map(list => (
								<button
									type='button'
									key={list.id}
									className={`${styles['format-converter__tab']} ${
										activeTabId === list.id
											? styles['format-converter__tab--active']
											: ''
									}`}
									onClick={() => setActiveTabId(list.id)}
									aria-label={list.title}
									aria-selected={activeTabId === list.id}
									role='tab'
								>
									<span className={styles['format-converter__tab-title']}>
										{list.title}
									</span>
								</button>
							))}
						</div>

						<div
							className={styles['format-converter__active-list']}
							role='tabpanel'
						>
							<h3 className={styles['format-converter__list-title']}>
								{activeList.title}
							</h3>
							<ul className={styles['format-converter__items']}>
								{activeList.items.map(item => (
									<li key={item.id}>
										<LinkWithQuery
											href={item.href}
											className={styles['format-converter__item']}
										>
											<span className={styles['format-converter__item-dot']} />
											<span className={styles['format-converter__item-text']}>
												{item.title}
											</span>
										</LinkWithQuery>
									</li>
								))}
							</ul>
						</div>
					</div>
				) : (
					<div className={styles['format-converter__desktop']}>
						<div className={styles['format-converter__lists-grid']}>
							{data.lists.map(list => (
								<div
									key={list.id}
									className={styles['format-converter__list-wrapper']}
								>
									<h3
										className={styles['format-converter__list-title']}
										style={list.color ? { background: list.color } : undefined}
									>
										{list.title}
									</h3>
									<ul className={styles['format-converter__items']}>
										{list.items.map(item => (
											<li key={item.id}>
												<LinkWithQuery
													href={item.href}
													className={styles['format-converter__item']}
												>
													<span
														className={styles['format-converter__item-dot']}
													/>
													<span
														className={styles['format-converter__item-text']}
													>
														{item.title}
													</span>
													<span
														className={styles['format-converter__item-arrow']}
													>
														<ArrowIcon />
													</span>
												</LinkWithQuery>
											</li>
										))}
									</ul>
								</div>
							))}
						</div>
					</div>
				)}
			</Container>
		</section>
	);
};
